import { observer } from "mobx-react-lite"
import React from 'react'
import { toastError, toastSuccess } from "../../FormComponents/Toasts"
import Modal from "../../Modal/Modal"
import axiosService from "../../../utils/AxiosService"

export default observer(function DeletePotentialInfluencerModal({ isOpen, setOpenDeleteModal, potentialInfluencer, getPotentialInfluencers }) {

const deletePotentialInfluencer = () => {
  axiosService.delete(`/api/project_manager/potential_influencers/${potentialInfluencer.id}`)
  .then(() => {
    toastSuccess('Potential Influencer deleted')
    getPotentialInfluencers()
  })
  .catch(({ data: { error } }) => toastError(error))
}

  return (
    <Modal isOpen={isOpen} onClose={() => setOpenDeleteModal(false)}>
      <Modal.Header>Delete Potential Influencer</Modal.Header>
      <Modal.Body>
        <div className="w-[400px]">
          <p className="mb-3 font-bold">Are you sure you want to delete this influencer: "{potentialInfluencer.name}"?</p>

          <div className="flex justify-between mt-5">
            <button
              type='button'
              className='rb-btn-cancel font-bold text-md ml p-2 px-4 rounded-lg'
              onClick={() => setOpenDeleteModal(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className='ml-auto bg-red-500 text-white rounded-lg p-2 px-4 submit text-center'
              onClick={deletePotentialInfluencer}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
})
